import { Action } from 'redux';
import {
  Observable,
  filter,
  withLatestFrom,
  mergeMap,
  from,
  catchError,
  of,
  exhaustMap
} from 'rxjs';
import {
  fetchGallery,
  fetchGallerySuccess,
  fetchGalleryFailure,
  appendGalleryItems,
} from '../slices';
import { selectGalleryState, selectSiteId } from '../selectors';
import { listGalleryFiles } from '../../services';

const DEFAULT_PAGE_SIZE = 20;

export const fetchGalleryEpic = (
  action$: Observable<Action>,
  state$: Observable<any>
) => {
  return action$.pipe(
    filter(fetchGallery.match),
    withLatestFrom(state$),
    exhaustMap(([_, state]) => {
      const { nextPageToken } = selectGalleryState(state);
      const siteId = selectSiteId(state);

      if (!siteId) {
        return from([
          fetchGalleryFailure('Site is not resolved yet.'),
        ]);
      }

      return from(
        listGalleryFiles({
          folder: `sites/${siteId}/thumbnail`,
          maxResults: DEFAULT_PAGE_SIZE,
          ...(nextPageToken && { pageToken: nextPageToken })
        })
      ).pipe(
        mergeMap((result) => {
          const actions = [];
          actions.push(
            fetchGallerySuccess({
              nextPageToken: result.nextPageToken
            })
          );
          actions.push(
            appendGalleryItems(result.items)
          );
      
          return from(actions);
        }),
        catchError((error) =>
          of(
            fetchGalleryFailure(
              error instanceof Error ? error.message : 'Failed to load gallery.'
            )
          )
        )
      );
    })
  );
};
